import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  validateEmail,
  validateLetters,
  validateLettersDigitsSpecChars,
} from "../../utils/Validators";
import { addUser } from "../../services/User";
import { getConsentText } from "../../services/Consent";
import LoadingSpinner from "./LoadingSpinner";
import ReadonlyOverlay from "./ReadonlyOverlay";

function UserRegistration() {
  const navigate = useNavigate();

  const [email, setEmail] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);
  const [consent3, setConsent3] = useState(false);
  const [consent2Text, setConsent2Text] = useState();
  const [consent3Text, setConsent3Text] = useState();

  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "firstName":
        if (validateLetters(value, 40, false)) setFirstName(value);
        break;
      case "lastName":
        if (validateLetters(value, 40, false)) setLastName(value);
        break;
      case "email":
        if (validateLettersDigitsSpecChars(value, 250, false)) setEmail(value);
        break;
      default:
    }
  };

  const handleUserRegister = async () => {
    const result = await addUser(
      email,
      firstName,
      lastName,
      true,
      consent1,
      consent2
    );
    if (result) navigate("/Register/Success/" + btoa(email));
    else navigate("/Register/Failure");
  };

  const validate = () => {
    setValid(
      validateLetters(firstName, 40, true) &&
        validateLetters(lastName, 40, true) &&
        validateEmail(email, true) &&
        consent1
    );
  };

  useEffect(() => {
    validate();
  }, [firstName, lastName, email, consent1]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const cons2 = await getConsentText(1);
      setConsent2Text(cons2);
      const cons3 = await getConsentText(2);
      setConsent3Text(cons3);
      setLoading(false);
    };
    fetchData();
  }, []);

  const isBeforeReleaseDate = new Date() < new Date("2025-05-06T09:00:00");

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-6 col-xl-5 mt-1">
          <div className="d-flex flex-column align-items-center mb-2">
            <img
              src="/assets/images/kig-e7Ti-vgY.png"
              alt="KIG"
              className="mx-auto"
            />
            <span className="text-white" style={{ fontSize: "0.75rem" }}>
              KRAJOWA IZBA GOSPODARCZA
            </span>
          </div>
        </div>
        <div className="col d-none d-md-block" />
      </div>

      <ReadonlyOverlay readonly={isBeforeReleaseDate}>
        <div className="row g-0 align-items-stretch mb-3">
          <div className="col-12 col-md-12 col-lg-6 col-xl-5 p-0">
            <div className="bg-white login-card-left h-100 d-flex flex-column justify-content-between p-4 p-xl-5">
              <div>
                <h1 className="display-4 text-center mb-1">
                  Rejestracja użytkownika
                </h1>
                <p className="text-muted text-center mb-4">
                  Elektroniczne świadectwo pochodzenia
                </p>

                <div className="d-flex flex-column w-100">
                  <div className="mb-1">
                    <label className="form-label">Adres email *</label>
                    <input
                      type="text"
                      className="form-control my-0 h2 rounded-3"
                      name="email"
                      value={email || ""}
                      onChange={handleInput}
                      maxLength="250"
                      placeholder="Adres email, np. jan.kowalski@email.com.pl (wypełnienie obowiązkowe)"
                      required
                    />
                  </div>

                  <div className="mb-1">
                    <label className="form-label">Imię *</label>
                    <input
                      type="text"
                      className="form-control my-0 h2 rounded-3"
                      name="firstName"
                      value={firstName || ""}
                      onChange={handleInput}
                      maxLength="40"
                      placeholder="Imię (wypełnienie obowiązkowe)"
                      required
                    />
                  </div>

                  <div className="mb-2">
                    <label className="form-label">Nazwisko *</label>
                    <input
                      type="text"
                      className="form-control my-0 h2 rounded-3"
                      name="lastName"
                      value={lastName || ""}
                      onChange={handleInput}
                      maxLength="40"
                      placeholder="Nazwisko (wypełnienie obowiązkowe)"
                      required
                    />
                  </div>

                  <div className="d-flex flex-row">
                    <button
                      type="button"
                      className="btn btn-outline-primary w7 h2 rounded-2"
                      onClick={() => navigate("/Login", { replace: true })}
                    >
                      Anuluj
                    </button>

                    {valid ? (
                      <button
                        type="button"
                        className="btn btn-primary w7 h2 rounded-2 ms-auto"
                        onClick={handleUserRegister}
                        disabled={!valid}
                      >
                        Zarejestruj
                      </button>
                    ) : (
                      <div
                        className="btn btn-primary w7 h2 rounded-2 ms-auto text-white opacity-50 tooltip"
                        disabled
                      >
                        Zarejestruj
                        <span className="tooltiptext">
                          Wypełnij wszystkie obowiązkowe pola i zaakceptuj
                          Regulamin Serwisu
                        </span>
                      </div>
                    )}

                    {/* {valid ? (
										<button type="submit" className="btn btn-primary w7 h2 rounded-2 ms-auto" onClick={handleUserRegister}>
											Zarejestruj
										</button>
									) : (
										<div className="btn btn-primary w7 h2 rounded-2 ms-auto text-white opacity-50 tooltip" disabled>
											Zarejestruj
											<span className="tooltiptext">Wypełnij wszystkie obowiązkowe pola i zaakceptuj Regulamin Serwisu</span>
										</div>
									)}
								</div> */}
                  </div>

                  {isBeforeReleaseDate && (
                    <div className="d-flex flex-row mt-1 ms-auto">
                      <strong>Dostępne od 6 maja 2025 r.</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col p-0">
            <div className="login-card-right h-100 d-flex flex-column justify-content-between p-3 p-xl-4 bg-light">
              {loading ? (
                <div className="p-2">
                  <LoadingSpinner text="Pobieranie treści oświadczeń" />
                </div>
              ) : (
                <div className="d-flex flex-column p-2 me-1 overflow-auto">
                  <span>
                    Administratorem Pani/Pana danych osobowych jest Krajowa Izba
                    Gospodarcza z siedzibą w Warszawie 00-074, ul. Trębacka 4,
                    tel.: 22 6309 600, email: kig@kig.pl. Pełna treść klauzuli
                    informacyjnej RODO znajduje się{" "}
                    <a
                      href="https://kig.pl/uslugi/karnety-ata-legalizacja/swiadectwa-pochodzenia-eksport/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tutaj
                    </a>{" "}
                    w sekcji RODO.
                  </span>

                  <div className="d-flex flex-row mt-1">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="consent1"
                      checked={consent1}
                      onChange={() => setConsent1(!consent1)}
                    />
                    <label className="form-check-label ms-2" htmlFor="consent1">
                      Zapoznałem się z{" "}
                      <a
                        href="/dokumenty/Regulamin_serwisu_eCO-wazny_od_06-05-2025.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Regulaminem Serwisu
                      </a>{" "}
                      i akceptuję jego treść. *
                    </label>
                  </div>

                  <div className="d-flex flex-row pt-1 mt-1 border-top border-primary-subtle">
                    <span>
                      Jeśli chcą państwo otrzymywać informacje o inicjatywach
                      realizowanych w ramach działalności statutowej Krajowej
                      Izby Gospodarczej, wspierającej rozwój przedsiębiorczości,
                      prosimy zaznaczyć poniższą zgodę:
                    </span>
                  </div>

                  <div className="d-flex flex-row my-1">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="consent2"
                      checked={consent2}
                      onChange={() => setConsent2(!consent2)}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="consent2"
                      dangerouslySetInnerHTML={{ __html: consent2Text }}
                    />
                  </div>

                  {/* 
                  <div className="d-flex flex-row my-1">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="consent3"
                      checked={consent3}
                      onChange={() => setConsent3(!consent3)}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor="consent3"
                      dangerouslySetInnerHTML={{ __html: consent3Text }}
                    />
                  </div>
                  */}

                  <span>
                    Administratorem Pani/Pana danych osobowych jest Krajowa Izba
                    Gospodarcza z siedzibą w Warszawie 00-074, ul. Trębacka 4,
                    tel.: 22 6309 600, email: kig@kig.pl. Pełna treść klauzuli
                    informacyjnej RODO{" "}
                    <a
                      href="https://kig.pl/wp-content/uploads/2025/04/Klauzula-informacyjna-newsletter-KIG.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      tutaj
                    </a>
                    .
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </ReadonlyOverlay>
    </div>
  );
}

export default UserRegistration;
